<!-- 使用前引入vuex 与vuex状态强相关

     采用插槽添加方式，引用更自由，如需更多插槽，请在直接在此添加并提交，注意已有插槽名称，并在下备注
     PC端插槽：preLevel0-preLevel3:同级插槽; separator1-separator2：分隔符插槽

     采用混入方式，上下文关联更强

     移动端目前只保留了最原始的登录功能本身，目前暂未添加插槽，如果需要，请自主添加，并在下备注
     移动端插槽:_
-->
<template>
	<div class="navigation-nav">
		<div class="login-div">
			<div>
				<div class="toplogin">
					<div class="home clearfix">
						<ul class="nav-top fr clearfix">
							<!-- PC端：未登录 -->
							<slot name="preLevel0"></slot>
							<li
								class="fl"
								v-if="
									isLoginState == false && windowWidth >= 769
								"
							>
								<a :href="loginUrl" class="nav_a" @click="login"
									>登录</a
								>
							</li>
							<slot name="preLevel1"></slot>
							<template v-if="isLoginState && windowWidth >= 769">
								<li class="fl" style="">
									<span
										href="javascript:;"
										class="nav_a"
										style="
											color: red;
											font-size: 14px;
											float: left;
											line-height: 21px;
										"
										>欢迎您，{{ userName }}</span
									>
									<i
										class="line2"
										style="display: block; float: left"
									></i>
									<slot name="separator1"></slot>
									<a
										ref="javascript:;"
										class="nav_a"
										@click="loginOut"
										>退出</a
									>
								</li>
								<slot name="Peer-level1"></slot>
							</template>
							<slot name="preLevel2"></slot>
							<li
								class="fl"
								v-if="
									isLoginState == false && windowWidth >= 769
								"
							>
								<slot name="separator2"></slot>
								<a href="https://user.drcnet.com.cn/#/regist"
									>注册</a
								>
							</li>
							<slot name="preLevel3"></slot>

							<!-- 移动端：统一下拉入口 -->
							<li
								v-if="windowWidth < 769"
								class="fl mobile-login-item"
								v-click-outside="closeMobileDropdown"
							>
								<a
									class="nav_a mobile-avatar"
									@click="toggleMobileDropdown"
								>
									<template v-if="isLoginState">
										<span class="avatar-text">{{
											userFirstChar
										}}</span>
									</template>
									<template v-else>
										<i class="el-icon-user"></i>
									</template>
								</a>
								<!-- 下拉菜单 -->
								<div
									v-show="mobileDropdownVisible"
									class="mobile-dropdown"
								>
									<!-- 未登录状态 -->
									<template v-if="isLoginState == false">
										<a
											:href="loginUrl"
											class="dropdown-item"
											@click="login"
											>登录</a
										>
									</template>
									<!-- 已登录状态 -->
									<template v-if="isLoginState">
										<div class="dropdown-item user-name">
											{{ userName }}
										</div>
										<div class="dropdown-divider"></div>
										<a
											class="dropdown-item logout"
											@click="loginOut"
											>退出登录</a
										>
									</template>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import isMixins from './index.js';
import { jsonp } from 'vue-jsonp';

// 点击外部关闭指令
const clickOutside = {
	bind(el, binding, vnode) {
		el._clickOutside = (event) => {
			if (!(el === event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.addEventListener('click', el._clickOutside);
	},
	unbind(el) {
		document.removeEventListener('click', el._clickOutside);
		delete el._clickOutside;
	},
};

export default {
	directives: { clickOutside },
	mixins: [isMixins],
	data() {
		return {
			loginUrl: '',
			windowWidth: window.innerWidth,
			mobileDropdownVisible: false,
		};
	},
	computed: {
		...mapState(['userName']),
		userFirstChar() {
			if (!this.userName || this.userName === 'defaultname') return '?';
			const trimmed = this.userName.trim();
			return trimmed ? trimmed.charAt(0) : '?';
		},
	},
	mounted() {
		this.updateWindowWidth();
		window.addEventListener('resize', this.updateWindowWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateWindowWidth);
	},
	methods: {
		updateWindowWidth() {
			this.windowWidth = window.innerWidth;
		},
		toggleMobileDropdown() {
			this.mobileDropdownVisible = !this.mobileDropdownVisible;
		},
		closeMobileDropdown() {
			this.mobileDropdownVisible = false;
		},
		login() {
			let url = 'https://user.drcnet.com.cn/#/login';
			this.loginUrl =
				url +
				'?gourl=' +
				window.location.href.replace('?', '~~').replace('&', '^');
			try {
				LogCollection.send(6);
			} catch (e) {}
		},
		loginOut() {
			this.closeMobileDropdown();
			let loginUrl =
				'https://user.drcnet.com.cn/userapi/loginController/logOutAllP';
			let _this = this;
			jsonp(loginUrl, { randomId: this.getRandom() })
				.then((res) => {
					_this.$nextTick(() => {
						this.SETUSERMESSAGE();
					});
				})
				.catch((err) => {
					this.SETUSERMESSAGE();
				});
		},
		getRandom() {
			let timestamp = Date.now();
			let randomNum = Math.random();
			let combined = timestamp + '_' + randomNum.toFixed(6);
			return combined;
		},
	},
};
</script>

<style lang="less" scoped>
.navigation-nav {
	display: -webkit-box;
	float: right;

	.login-div {
		.toplogin {
			background: none;
			line-height: 18px;
			border-bottom: none;

			.nav-top {
				height: 25px;
				border-radius: 12px;
				padding: 0 15px;
				box-sizing: border-box;

				li {
					line-height: 20px;

					a {
						font-size: 14px;
						color: #03c;
						text-decoration: none;
						font-family: Microsoft YaHei;
						line-height: 20px;
					}

					.line2 {
						width: 2px;
						background: #fff;
					}
				}
			}

			.home {
				width: auto !important;
				box-sizing: border-box;
			}
		}
	}
}

.clearfix {
	zoom: 1;
}

.fr {
	float: right;
}

.nav_a {
	cursor: pointer;
}

// 移动端适配
@media screen and (max-width: 768px) {
	.navigation-nav {
		.login-div {
			.toplogin {
				.nav-top {
					height: auto;
					padding: 0;

					li {
						a {
							font-size: 12px;
							color: #333333 !important;
						}

						&.mobile-login-item {
							position: relative;

							.mobile-avatar {
								display: flex;
								align-items: center;
								justify-content: center;
								width: 28px;
								height: 28px;
								border-radius: 50%;
								background: rgba(255, 255, 255, 0.2);
								transition: background 0.2s;
								overflow: hidden;
								cursor: pointer;

								&:hover {
									background: rgba(255, 255, 255, 0.35);
								}

								i {
									font-size: 16px;
									color: #fff;
								}

								.avatar-text {
									font-size: 14px;
									color: #fff;
									font-weight: bold;
									line-height: 1;
								}
							}

							.mobile-dropdown {
								position: absolute;
								top: calc(100% + 6px);
								right: 0;
								min-width: 120px;
								background: #fff;
								border-radius: 6px;
								box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
								padding: 6px 0;
								z-index: 1000;

								.dropdown-item {
									display: block;
									padding: 8px 14px;
									font-size: 13px;
									color: #333;
									text-decoration: none;
									white-space: nowrap;
									cursor: pointer;
									transition: background 0.15s;

									&:hover {
										background: #f5f7fa;
									}

									&.user-name {
										color: #666;
										cursor: default;
										font-weight: 500;

										&:hover {
											background: transparent;
										}
									}

									&.logout {
										color: #f56c6c !important;
									}
								}

								.dropdown-divider {
									height: 1px;
									background: #ebeef5;
									margin: 4px 0;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>
